import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import PopupComponent from '@app/shared/popup/popup.component';
import AppComponentBase from '@shared/common/app-component-base';
import UtilsModule from '@shared/utils/utils.module';

import ClientAddPopupFormComponent from './form/client-add-popup-form.component';

@Component({
    selector: 'app-client-add-popup',
    imports: [
        UtilsModule,
        PopupComponent,
        ClientAddPopupFormComponent,
    ],
    templateUrl: './client-add-popup.component.html',
})
class ClientAddPopupComponent extends AppComponentBase {
    constructor(
        injector: Injector,
        private router: Router,
        private dialogRef: MatDialogRef<ClientAddPopupFormComponent>,
    ) {
        super(injector);
    }

    onSubmit(id: number) {
        this.dialogRef.close();
        this.router.navigate(['/app/clients/edit/' + id]);
    }
}

export default ClientAddPopupComponent;
